import { Box } from "@mui/material";
import React from "react";

import { ProfileSection } from "../../../types/user";

import ProfileAddress from "./ProfileAddress";
import ProfileChangePassword from "./ProfileChangePassword";
import ProfileOrders from "./ProfileOrders";
import ProfilePersonalInfo from "./ProfilePersonalInfo";
import ProfileReferral from "./referral/ProfileReferral";
import ProfileSupport from "./ProfileSupport";
import ProfileWishlist from "./ProfileWishlist";

interface ProfileInfoProps {
  user: unknown;
  section: ProfileSection;
}

const ProfileInfo: React.FC<ProfileInfoProps> = ({ section }) => {
  const renderContent = () => {
    switch (section) {
      case "personal":
        return <ProfilePersonalInfo />;
      case "orders":
        return <ProfileOrders />;
      case "wishlist":
        return <ProfileWishlist />;
      case "address":
        return <ProfileAddress />;
      case "changePassword":
        return <ProfileChangePassword />;
      case "support":
        return <ProfileSupport />;
      case "referral":
        return <ProfileReferral />;
      default:
        return <ProfilePersonalInfo />;
    }
  };

  return <Box>{renderContent()}</Box>;
};

export default ProfileInfo;
